export const FORMAT_MASK = '____-__-__';
